import { Result } from 'core';
import { z, ZodType, ZodTypeDef } from 'zod';
export type Uuid = string;

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export function getParsedResult<
  Input extends {},
  Output extends { readonly [key in keyof Input]: any },
>(
  resultRows: readonly any[] | undefined,
  schema: ZodType<Output, ZodTypeDef, Input>
): Result.Type<Output, Error> {
  const parsed = schema.safeParse(resultRows);
  return parsed.success
    ? Result.success(parsed.data)
    : Result.failure(new Error('Could not parse data', { cause: parsed.error }));
}

// This covers the case of z.coerce.date().parse(null) = true
const datelike = z.union([z.number(), z.string(), z.date()]);
export const zodDate = datelike.pipe(z.coerce.date());

// Secrets stored in SecretsManager are accessed through a <secret name> and returns an object
// To keep it simple we're going to assume that each object contains a single kv pair keyed with the word 'secret'
export const SECRET_REF = 'secret' as const;
